'use client';

import { useCallback } from 'react';

import { useTranslations } from 'next-intl';

/**
 * Localized add-on title from booking messages (addOnCatalog namespace).
 */
export function useAddOnDisplayName() {
  const t = useTranslations('booking.addOnCatalog');
  return useCallback((id: string) => t(`${id}.name` as never), [t]);
}
